import {MotorList} from "./MotorList";
import {MotorEdit} from "./MotorEdit";
import {MotorCreate} from "./MotorCreate";

export default {
    list: MotorList,
    create: MotorCreate,
    edit: MotorEdit
};
